import styled from 'styled-components/macro';

export const Details = styled.div`
  color: #262626;
  margin-top: 2px;
  text-align: left;
`;
